import { VoucherCard } from 'components/SpaceBooking/types';
import { VoucherCardValueGrid } from 'components/SpaceBooking/VoucherCard/VoucherCardValueGrid';
import moment from 'moment';

interface Props {
    voucher: VoucherCard;
    initalValue?: number;
    newValue?: number;
    disabled?: boolean;
    callback?: (newValue: number) => void;
    small?: true;
}

export const VoucherCardComponent = ({ voucher, callback, small, initalValue, newValue, disabled }: Props) => {
    return (
        <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-12">
                <div className="tw-relative tw-flex tw-gap-2">
                    <img
                        className="tw-relative"
                        width={40}
                        height={40}
                        src={`${process.env.NEXT_PUBLIC_API_HOST}image/${voucher.user?.image}`}
                        alt={`#${voucher.id} | ${voucher.user?.name}`}
                    />
                    <div>
                        <p className="tw-m-0 tw-font-bold">{voucher.user_email}</p>
                        <small className="tw-text-accents-7">
                            #{voucher.id} | {voucher.user?.name}
                        </small>
                    </div>
                </div>
            </div>
            {!small && (
                <div className="tw-col-span-12">
                    <div className="tw-card-bordered tw-bg-accents-1">
                        <div>
                            <div className="tw-flex tw-justify-between">
                                <b>Ausgestellt am</b>
                                <p className="tw-m-0">{moment(voucher.created_at).format('lll')}</p>
                            </div>
                            <div className="tw-flex tw-justify-between">
                                <b>Zuletzt geändert am</b>
                                <p className="tw-m-0">{moment(voucher.updated_at).format('lll')}</p>
                            </div>
                            <div className="tw-flex tw-justify-between">
                                <b>Preis</b>
                                <p className="tw-m-0">{voucher.price} €</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="tw-col-span-12">
                <VoucherCardValueGrid
                    onChange={callback}
                    newValue={newValue}
                    initialValue={initalValue}
                    preview={disabled}
                    voucher={voucher}
                />
            </div>
        </div>
    );
};
